"use strict";

/** Используется во время сборки для определения переменных.
 *  Конвертируется в файл build_vars.js
 * @see grunt file task replace
 */
export var BUILD_VARS = {
  //переменные которые используются во время сборки проекта
  CORE_NODE_ENV: 'development',
  //production, если это dev, то тут будет development
  CORE_VERSION: 'dev v. 5.1.90161',
  //v. + build version
  USER_SCRIPT_VER: 'user script v. 5.1.90161' // //v. + build version

};